import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    cocaAnnualTabIndex: 0,
    isLoading: false,
    error: null
}

const CocaAnnualSlice = createSlice({
    name: 'cocaAnnual',
    initialState,
    reducers: {
        setCocaAnnualTabIndex: (state, action) => {
            state.cocaAnnualTabIndex = action.payload;
        },
        resetCocaAnnualState: (state) => {
            state.cocaAnnualTabIndex = 0;
            state.isLoading = false;
            state.error = null;
        }
    }
});

export const { setCocaAnnualTabIndex, resetCocaAnnualState } = CocaAnnualSlice.actions;

export default CocaAnnualSlice.reducer;
